<script setup lang="ts">
import Message from "primevue/message";

/**
 * What the server said, above the form it belongs to.
 *
 * A list, because the validation on the other side reports one entry per
 * rejected field.
 */
defineProps<{ messages: string[] }>();
</script>

<template>
  <div v-if="messages.length > 0" class="stack" role="alert">
    <Message
      v-for="(message, index) in messages"
      :key="index"
      severity="error"
      :closable="false"
    >
      {{ message }}
    </Message>
  </div>
</template>
